import React, { useRef, useState, useEffect, useMemo, forwardRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { FaCheck, FaDownload, FaFilter, FaPen, FaPlus, FaSearch, FaSyncAlt, FaTimes, FaTrash } from 'react-icons/fa';
import { API_URL_All } from '../../api';
import axios from "axios";
import { toast } from "react-toastify";
import * as general from '../../libs/general';
import { CheckingTicket, LockingTicket } from '../tickets/Tickets';
import axiosInstance from '../../axiosInstance';
import ReconciliationPaymentConfirmModal, { buildPaymentSummary } from '../reconciliation/ReconciliationPaymentConfirmModal';

const ContactOrderReview = ({ data, handleSearch, canEdit = false, canDelete = true, nestedModal = false }) => {
  const [visibleMiniPopup, setVisibleMiniPopup] = useState(true);
  const [removedItems, setRemovedItems] = useState([]);

  const [show, setShow] = useState(true);
  const [isLocked, setIsLocked] = useState(true);
  const [model, setModel] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [loadingExport, setLoadingExport] = useState(false);
  const [loadingConfirm, setLoadingConfirm] = useState(false);
  const [showPaymentConfirm, setShowPaymentConfirm] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [removingOrderId, setRemovingOrderId] = useState(null);

  const filteredItems = useMemo(() => {
    const items = Array.isArray(model?.items) ? model.items : [];
    if (data?.lineId == null) return items;
    return items.filter((item) => Number(item?.lineId) === Number(data.lineId));
  }, [model, data?.lineId]);

  const displayedStats = useMemo(() => {
    if (data?.lineId == null) {
      return {
        orderCount: model.orderCount,
        totalPackageUnitValue: model.totalPackageUnitValue,
        totalPackageUnitM3: model.totalPackageUnitM3,
        contactFee: model.contactFee,
      };
    }
    const sum = (key) => filteredItems.reduce((t, it) => t + (Number(it?.[key]) || 0), 0);
    return {
      orderCount: filteredItems.length,
      totalPackageUnitValue: sum('weight'),
      totalPackageUnitM3: sum('size'),
      contactFee: sum('contactFee'),
    };
  }, [data?.lineId, model, filteredItems]);

  useEffect(() => {
    setVisibleMiniPopup(true);
    retrieveModalData(data);
  }, [data]);

  const retrieveModalData = async (params) => {
    if (params.id) {
      try {
        var urlApi = `/api/invoices/getContactInvoice?id=${params.id}`;
        const response = await axiosInstance.get(urlApi);
        var obj = response.data;
        if (obj.success === false) {
          toast.error(obj.message);
          return;
        }
        var model = obj.data;
        model.checkingItems = model.items.filter(item => item.contactingId !== null && item.contactingId !== 13);
        setModel(model);
        setShow(true);
      } catch (error) {
        console.error(error);
        setModel({ error: error.message });
        toast.error(error.message);
      }
      return;
    }
    const textIds = params.listIds.join(';');
    setModel({});
    try {
      var urlApi = `/api/invoices/getInvoiceContactReview`;
      var listIds = { codes: params.listIds.join(';') };
      const response = await axiosInstance.post(urlApi, listIds , 
        { headers: { 'Content-Type': 'application/json' } });
      var obj = response.data;
      if (obj.success === false) {
        toast.error(obj.message);
        return;
      }

      setModel(obj.data);
      var model = obj.data;
      model.checkingItems = model.items.filter(item => item.contactingId !== null && item.contactingId !== 13);
      setModel(model);
      setShow(true);
    } catch (error) {
      console.error(error);
      setModel({ error: error.message });
      toast.error(error.message);
    }
  };


  const handleModalClose = (e) => {
    document.querySelectorAll('.show .error-msg').forEach((item) => {
      if (item.parentNode) {
        item.parentNode.removeChild(item);
      }
    });
    document.activeElement.blur();
    setShow(false);

    setRemovedItems([]);
    if (nestedModal && handleSearch) {
      handleSearch();
    }
  };

  const handleSubmitForm = async(e) => {
    e.preventDefault();
    var errorTag = e.currentTarget.querySelector('.error-msg');
    if (errorTag) return;

    setLoadingSubmit(true);
    try {
      var requestApi = `/api/invoices/saveContactOrderInvoice`;

      const response = await axiosInstance.post(requestApi, model);
      if (!response.data.success) {
        general.showFormError('.show .modal-body', response.data);
        console.log(response.data);
        return;
      }
      console.log(response);
      toast.success(response.data.message);
      console.log(response.data);
      if (handleSearch) handleSearch();
      await retrieveModalData({ id: response.data.data });
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoadingSubmit(false);
    }

  };

  const handleExportInvoice = async (param) => {
    setLoadingExport(true);
    try {
      var requestApi = `${API_URL_All}/api/invoices/exportContactInvoice?id=${param.id}`;
      var fileName = `Doi_soat_doi_tac_${param.id}.xlsx`;
      if (!param.id) {
        fileName = `Doi_soat_doi_tac_preview.xlsx`;

        const avaiableIds = data.listIds.filter(id => !removedItems.includes(id));
        const codes = avaiableIds.join(';');
        requestApi = `${API_URL_All}/api/invoices/exportContactInvoice?codes=${codes}`;
      }
      await general.downloadFile(requestApi, fileName);
    } finally {
      setLoadingExport(false);
    }
  };

  const handlePaymentConfirm = () => {
    if (!canEdit) {
      toast.warning("Bạn không có quyền cập nhật đối soát.");
      return;
    }
    setShowPaymentConfirm(true);
  };

  const handlePaymentSuccess = () => {
    if (handleSearch) handleSearch();
    handleModalClose();
  };

  const getClassWarning = (contactingId) => {
    if (!contactingId || contactingId === 13) {
      return "";
    }
    return "contacting";
  };

  const handleRemoveOrder = async (orderId) => {
    setRemovingOrderId(orderId);
    try {
      const updatedRemovedItems = [...removedItems, orderId];
      setRemovedItems(updatedRemovedItems);

      const newListIds = data.listIds.filter(
        id => !updatedRemovedItems.includes(id)
      );

      const updatedData = { ...data, listIds: newListIds };
      await retrieveModalData(updatedData);
    } finally {
      setRemovingOrderId(null);
    }
  }
  const handleDeletInvoice = (e) => {
    if (!canDelete) return;
    general.openConfirm(async () => {
      setLoadingDelete(true);
      try {
        var requestApi = `/api/invoices/deleteContactInvoice?id=${model.id}`;
        const response = await axiosInstance.get(requestApi);

        if (!response.data.success) {
          toast.error(response.data.message);
          return;
        }
        toast.success(response.data.message);
        if (handleSearch) handleSearch();
        handleModalClose();

      } catch (error) {
        console.error(error);
        toast.error(error.message);
      } finally {
        setLoadingDelete(false);
      }
    })
  };

  return (
    <>
    <Modal
      show={show}
      onHide={handleModalClose}
      size="fullscreen"
      dialogClassName="modal-popupfull"
      className={nestedModal ? "accounting-nested-modal" : ""}
      backdropClassName={nestedModal ? "accounting-nested-modal-backdrop" : undefined}
      enforceFocus={!nestedModal}
    >
      <div className="modal-dialog11 modal-fullscreen11">
        <form id="order_editor_form" className="form_validate normal-form" autoComplete="off" onSubmit={handleSubmitForm}>
          <div className="modal-content">
            <div className="modal-header position-relative flex-between">
              {model.id && (<span className="record_id">ID: {model.id}</span>)}
              <div>
                <h5 className="modal-title">{model.id ? `Đối tác: Chi tiết hóa đơn` : 'Đối tác: Xem trước hóa đơn đối soát'}</h5>
                {model.error && (
                  <div className="error-msg-server">{model.error}</div>
                )}
              </div>
              <button
                type="button"
                className="btn-close"
                onClick={handleModalClose}
                aria-label="Đóng"
              ></button>
            </div>
            <div className="modal-body">

              <div>

                <div className="row mb-2">
                  <div className="col-md-6">
                    <div className="row">
                      <label className="form-label col-md-3">Đối tác: </label>
                      <div className="col-md-9">
                        <b>{model.contactCode}</b>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <label className="form-label col-md-3">Ngày đối soát: </label>
                      <div className="col-md-2">
                        <b>{model.createdTimeText}</b>
                      </div>
                      <div className="col-md-7">
                        <CheckingTicket checkingId={model.checkingId} checkingName={model.checkingName} />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mb-2">
                  <div className="col-md-6">
                    <div className="row">
                      <label className="form-label col-md-3">Tổng đơn: </label>
                      <div className="col-md-9">
                        <b>{general.formatNumber(displayedStats.orderCount)}</b>
                      </div>
                    </div>
                  </div>
                </div>

              <div className="row mb-2">
                <div className="col-md-6">
                  <div className="row">
                    <label className="form-label col-md-3">Tổng cân: </label>
                    <div className="col-md-9">
                      <b>{Number.isFinite(displayedStats.totalPackageUnitValue)
                          ? displayedStats.totalPackageUnitValue.toFixed(2)
                          : '0.00'} {'(kg)'}
                      </b>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="row">
                    <label className="form-label col-md-3">Tổng M3: </label>
                    <div className="col-md-9">
                      <b>{Number.isFinite(displayedStats.totalPackageUnitM3)
                          ? displayedStats.totalPackageUnitM3.toFixed(2)
                          : '0.00'} {'(m3)'}
                      </b>
                    </div>
                  </div>
                </div>
              </div> 

              <div className="row mb-2">
                <div className="col-md-6">
                    <div className="row">
                      <label className="form-label col-md-3">Tổng phí ĐT: </label>
                      <div className="col-md-9">
                        <b>{general.formatNumber(displayedStats.contactFee)}</b>
                    </div>
                  </div>
                  </div>

                  <div className="col-md-6">
                    <div className="row">
                      {model.id && (
                        <div className="col-md-12">
                          <div className="row">
                            <label className="form-label col-3">Nội dung: </label>
                            <div className="col-9">
                              <b>{model.name}</b>
                            </div>
                          </div>
                        </div>
                      )}
                      {!model.id && (
                        <div className="col-md-12">
                          <div className="row">
                            <label className="form-label col-form-label col-3"><span className="required1">Nội dung</span></label>
                            <div className="col-9">
                              <input type="text" className="form-control" placeholder="Nội dung đối soát" data-required1="Phải nhập mục này" autoComplete="off" value={model.name} onChange={(e) => setModel({ ...model, name: e.target.value })} />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
              </div>

              </div>

              <section className="p-1 ">
                <div className="table-responsive border table-normal table-sticky">
                  <table className="table table-striped border-normal table-bordered">
                    <thead className="table-primary head-01">
                      <tr>
                        <th className='sticky text-center' width="21px">STT</th>

                        <th className="text-center">Mã bao</th>
                        <th className="text-center">Mã vận đơn TQ</th>
                        <th><span>Line</span></th>

                        <th className="text-center">Số kiện</th>

                        <th className="text-center"><span data-note="">KG</span></th>
                        <th className="text-center"><span data-note="">M3</span></th>

                        <th className="text-center"><span data-note="">Phụ phí ĐT</span></th>
                        <th className="text-center"><span data-note="">Thành tiền ĐT</span></th>

                        <th className="text-center"><span>Ngày</span></th>
                        <th>Lưu trình</th>
                        <th className="text-center">Mã KH</th>
                        {!model.id && (
                          <th></th>
                        )}
                      </tr>
                    </thead>
                    {filteredItems.map((item, index) => (
                      <tbody className="tbody-row">
                        <tr key={index} className={getClassWarning(item.contactingId)}>
                          <td className='sticky text-center' title={`orderId: ${item.id}`}>
                            {index + 1}
                          </td>
                          <td className="text-success text-center">{item.sackCode}</td>
                          <td className="text-success text-center">{item.cnCode}</td>
                          <td className='text-success text-start' title={`orderId: ${item.orderId}`}>{item.lineName}</td>


                          <td className="text-success text-center">{item.packageCount}</td>
                          <td className="text-success text-center">{general.formatDecimal(item.weight)}</td>
                          <td className="text-success text-center">{general.formatDecimal(item.size)}</td>

                          <td className="text-success text-center">{general.formatNumber(item.contactFeeSurcharge)}</td>
                          <td className="text-success text-center" title={`Fee: ${general.formatNumber(item.fee)}`}>{general.formatNumber(item.contactFee)}</td>

                          <td className="text-success text-center" title={item.lineName}>{general.formatDate(item.orderDate)}</td>
                          <td className="text-success text-start text-truncate mw-101" >{item.progressName}</td>
                          <td className="text-success text-center text-truncate mw-101" title={item.note}>{item.customerCode}</td>
                          {!model.id && (
                            <td>
                              <button
                                type="button"
                                className="btn p-0 border-0 bg-transparent"
                                onClick={() => handleRemoveOrder(item.orderId)}
                                title="Xóa đơn hàng"
                                disabled={removingOrderId === item.orderId}
                              >
                                {removingOrderId === item.orderId ? (
                                  <span className="spinner-border spinner-border-sm text-danger" role="status" aria-hidden="true" />
                                ) : (
                                  <FaTrash className="text-danger" size={15} />
                                )}
                              </button>
                            </td>
                          )}
                        </tr>
                      </tbody>
                    ))}


                    <tbody>
                      {errorMessage === '' && loaded && filteredItems.length === 0 && (
                        <tr>
                          <td colSpan="21" className="text-center">Không tìm thấy dữ liệu</td>
                        </tr>
                      )}
                      {errorMessage !== '' && (
                        <tr>
                          <td colSpan="21" className="text-center">{errorMessage}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </section>








            </div>
            <div className="modal-footer text-end">
              {!model.id && (
                
                <div className="flex-between w-100">
                  <div className="d-flex align-items-center">
                    <button
                      type="button"
                      className="btn-sm btn btn-primary me-2 d-inline-flex align-items-center gap-1"
                      disabled={loadingExport}
                      onClick={() => handleExportInvoice({ codes: model.codes })}
                    >
                      {loadingExport ? (
                        <>
                          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                          Đang xuất...
                        </>
                      ) : (
                        <>
                          <FaDownload size={12} /> Xuất excel
                        </>
                      )}
                    </button>
                    
                  </div>
                  <div>

                    <button
                      type="submit"
                      className="btn-sm btn btn-primary d-inline-flex align-items-center gap-1"
                      disabled={loadingSubmit}
                    >
                      {loadingSubmit ? (
                        <>
                          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                          Đang xử lý...
                        </>
                      ) : (
                        <>
                          <FaCheck size={12} /> Xác nhận đối soát
                        </>
                      )}
                    </button>
                  </div>
                </div>

              )}
              {model.id && (
                <div className="flex-between w-100">
                  <div className="d-flex align-items-center">
                    <button
                      type="button"
                      className="btn-sm btn btn-primary me-2 d-inline-flex align-items-center gap-1"
                      disabled={loadingExport}
                      onClick={() => handleExportInvoice({ id: model.id })}
                    >
                      {loadingExport ? (
                        <>
                          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                          Đang xuất...
                        </>
                      ) : (
                        <>
                          <FaDownload size={12} /> Xuất excel
                        </>
                      )}
                    </button>
                    {canDelete && model.isAdmin && (
                      <button
                        type="button"
                        className="btn-small d-inline-flex align-items-center gap-1"
                        disabled={loadingDelete}
                        onClick={() => handleDeletInvoice()}
                      >
                        {loadingDelete ? (
                          <>
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                            Đang xóa...
                          </>
                        ) : (
                          <>
                            <FaTrash size={12} /> Xóa
                          </>
                        )}
                      </button>
                    )}
                  </div>
                  <div>
                    {model.checkingId === 14 && canEdit && (
                      <button
                        type="button"
                        className="btn-sm btn btn-primary me-2 d-inline-flex align-items-center gap-1"
                        disabled={loadingConfirm}
                        onClick={() => handlePaymentConfirm()}
                      >
                        {loadingConfirm ? (
                          <>
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                            Đang xử lý...
                          </>
                        ) : (
                          <>
                            <FaCheck size={12} /> Xác nhận thanh toán
                          </>
                        )}
                      </button>
                    )}
                    <button
                      onClick={() => handleModalClose()}
                      type="button"
                      className="btn-sm btn btn-secondary d-inline-flex align-items-center gap-1"
                    >
                      <FaTimes size={12} /> Đóng
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </form>
        {model.checkingItems && model.checkingItems.length > 0 && visibleMiniPopup && (

          <div className="mini-popup top_right">
            <div className="mini-popup-header">
              <span>Mã đơn đã đối soát</span>
              <i className="close-i close-i0" title="Close" onClick={(e) => setVisibleMiniPopup(false)}></i>
            </div>
            <div>
              {model.checkingItems.map((item, index) => (
                <div className="mini-popup-item" key={index}>{item.cnCode}</div>
              ))}
            </div>
          </div>
        )}

      </div>
    </Modal>
    <ReconciliationPaymentConfirmModal
      show={showPaymentConfirm}
      onHide={() => setShowPaymentConfirm(false)}
      onSuccess={handlePaymentSuccess}
      completeApi="/api/invoices/completeContactInvoice"
      payloadBase={model}
      summary={buildPaymentSummary(model, "partner")}
      accountLabel="Tài khoản chi tiền"
    />
    </>
  );
};

export default ContactOrderReview;
